import React, { useEffect, useState } from 'react';
import { RootState } from 'app/redux/store';
import ImagePath from 'app/utilities/imagePath';
import { checkPasswordAction, setCheckPasswordAction } from 'app/redux/actions/LoginAction';
import { useDispatch, useSelector } from 'react-redux';
import { passwordForm } from 'app/configs/withdrawForm.config';
import { IModalProps } from '../../interfaces/modalProps.interface';
import './CheckPasswordModal.scss';
import Button from '../Button/Button';
import InputComponent from '../InputComponent/InputComponent';

const CheckPasswordModal = function init(props: IModalProps): React.ReactElement {
    const { isValidated, errorCheckPassword } = useSelector((state: RootState) => state.loginReducer);
    const { loading } = useSelector((state: RootState) => state.commonReducer);
    const { setOpenModal, isOpenModal, action } = props;
	const dispatch = useDispatch();
    const [authForm] = useState(passwordForm);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const [invalidPassword, setInvalidPassword] = useState(true);

    function closeModal(): void {
        setOpenModal(false);
    }

    function authFormOnChangeHandle(event: Record<string, string>): void {
		const fieldForm = authForm.find((field) => field.name === event.name);
		if (fieldForm?.id === 'password') {
			fieldForm.apiErrorMessage = errorCheckPassword;
			fieldForm.value = event.value;
			if (event.value.length > 7) {
				setInvalidPassword(false);
				fieldForm.apiErrorMessage = '';
			} else {
				setInvalidPassword(true);
				fieldForm.apiErrorMessage = 'Minimum password 7 karakter';
			}
		}
	}

    function checkPasswordFormOnSubmit(event: React.FormEvent<HTMLFormElement>): void {
		event.preventDefault();

        const fieldForm = authForm[0];
        if (fieldForm.apiErrorMessage === '') {
            dispatch(checkPasswordAction({ password: authForm.find((field) => field.id === 'password')?.value as string }));
        }
	}

    useEffect(() => {
        const fieldForm = authForm[0];
        if (errorCheckPassword) {
            setInvalidPassword(true);
            fieldForm.apiErrorMessage = errorCheckPassword;
        } else {
            setInvalidPassword(false);
            fieldForm.apiErrorMessage = '';
        }
    }, [errorCheckPassword]);

    useEffect(() => {
        if (isValidated) {
            dispatch(setCheckPasswordAction(false));
            action?.();
        }
    }, [isValidated]);

    useEffect(() => {
        if (!isOpenModal) {
            authForm[0].value = '';
        }
    }, [isOpenModal]);

    return (
        <div className="mainContainer">
            <div className="titleContainer">
                <h3>Masukan Kata Sandi</h3>
                <button
                    className="imageContainer btn"
                    type="button"
                    onClick={() => closeModal()}
                >
                    <img src={ImagePath.close.src} alt={ImagePath.close.alt} />
                </button>
            </div>
            <div>
				<form onSubmit={(event) => checkPasswordFormOnSubmit(event)}>
					{authForm.map((each) => (
						<InputComponent
							key={each.id}
							id={each.id}
							formType={each.formType}
							placeholder={each.placeholder}
							name={each.name}
							apiErrorMessage={each.apiErrorMessage}
							value={each.value}
                            disabled={loading}
							options={each.options}
							onChange={(event) => {
								authFormOnChangeHandle(event);
							}}
						/>
					))}
					<div className="btn-container">
						<Button
							buttonText="Lanjut"
							disabled={authForm[0].apiErrorMessage !== '' || (authForm[0].value ?? '').toString().length < 7 || loading}
                            loading={loading}
						/>
					</div>
				</form>
            </div>
        </div>
    );
};

export default CheckPasswordModal;
